import {
  DistributorFeeSourceApproved,
  DistributorFeeSourceRejected,
  DistributorFeeStatusCreated,
  DistributorFeeStatusFinanceAdjusted,
  DistributorFeeStatusFinanceConfirmed,
} from 'utils/distributorFee'

export const DISTRIBUTOR_FEE_IN = {
  [DistributorFeeStatusCreated]: 'Mới',
  [DistributorFeeStatusFinanceAdjusted]: 'Kế toán chỉnh sửa',
  [DistributorFeeStatusFinanceConfirmed]: 'Kế toán xác nhận',
  [DistributorFeeSourceApproved]: 'Sourcing đã duyệt',
  [DistributorFeeSourceRejected]: 'Sourcing từ chối',
}
